import currencyFormatter from "./currencyFormatter";

export default (value? : number | null, emptyPlaceholder : string = "-") : string => {
	if (value === undefined || value === null) {
		return emptyPlaceholder;
	}

	return currencyFormatter.format(value);
}
